import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { MillDashboardContext } from "./MillDashboardsContext";
import { IMillDashboardsContextProps } from "./MillDashboardsContextInterfaces";
import { initialState } from "./MillDashboardsContext";
import { EventReportsEntity } from "entities/EventReports/EventReportsEntity";
import { PENDING_SECONDARY_CODES_POLL_INTERVAL } from "constants/constants";

export const MillDashboardContextProvider: React.FC<IMillDashboardsContextProps> = ({ children }) => {
    const [showDetails, setShowDetails] = useState<boolean>(initialState.showDetails);
    const [displayUnit, setDisplayUnit] = useState<string | number>(initialState.displayUnit);
    const [showOnlyPending, setShowOnlyPending] = useState<boolean>(true);
    const [topHeaderArea, setTopHeaderArea] = useState(initialState.topHeaderArea);
    const [reportRangeEndDate, setReportRangeEndDate] = useState(initialState.reportRangeEndDate);
    const [reportRangeStartDate, setReportRangeStartDate] = useState(initialState.reportRangeStartDate);

    const { millId } = useParams();
    const millIdNumber = useMemo(() => (Boolean(millId) ? Number(millId) : 0), [millId]);

    const { pendingEventReportsCount, refetch, startPolling, stopPolling, setPendingEventReportsCount } =
        EventReportsEntity.GetPendingEventReportsWithSecondaryCodesBOLive(millIdNumber);

    useEffect(() => {
        if (millIdNumber) {
            startPolling(PENDING_SECONDARY_CODES_POLL_INTERVAL);
            return () => stopPolling();
        }
    }, [millIdNumber, startPolling, stopPolling]);

    const showOrHideDetails = (value: boolean) => {
        setShowDetails(value);
    };

    const handleChangeDisplayUnit = (value: string | number) => {
        setDisplayUnit(value);
    };

    const showOrHideOnlyPending = (value: boolean) => {
        setShowOnlyPending(value);
    };

    const handleSetTopHeaderArea = (value: React.ReactNode) => {
        setTopHeaderArea(value);
    };

    const handleSetReportRangeEndDate = (value: Date) => {
        setReportRangeEndDate(value);
    };

    const handleSetReportRangeStartDate = (value: Date) => {
        setReportRangeStartDate(value);
    };

    const providerValue = {
        showDetails,
        showOnlyPending,
        showOrHideOnlyPending,
        showOrHideDetails,
        displayUnit,
        handleChangeDisplayUnit,
        topHeaderArea,
        handleSetTopHeaderArea,
        reportRangeEndDate,
        handleSetReportRangeEndDate,
        reportRangeStartDate,
        handleSetReportRangeStartDate,
        pendingEventReportsCount,
        setPendingEventReportsCount,
        refreshPendingEventReportsCount: refetch,
    };

    return <MillDashboardContext.Provider value={providerValue}>{children}</MillDashboardContext.Provider>;
};
